module.exports = __webpack_public_path__ + "static/heroslide-1-c927113bc2111b6663cb2ba478dd77a4.png";